import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext(null);

const DICT = {
  ru: {
    'nav.home': 'Главная',
    'nav.models': 'Модели',
    'nav.actresses': 'Актрисы',
    'nav.dancers': 'Танцовщицы',
    'nav.contests': 'Конкурсы',
    'nav.rules': 'Правила',
    'nav.contacts': 'Контакты',

    'header.vote': '🔥 Голосовать',
    'header.register': 'Зарегистрироваться',

    'common.back': 'Назад',
    'common.forward': 'Вперёд',
    'common.pageOf': 'Стр. {page} из {total}',

    'vote.nominations': 'Номинации:',
    'vote.liveCounter': '581 человек сейчас голосуют с вами',
    'vote.title': 'Примите участие в голосовании и выберите лучшую модель Ростова',
    'vote.subtitle': 'Выбор Ростова начинается здесь',
    'vote.banner': 'Голоса принимаются раз в час. Сделайте свой выбор!',
    'vote.voteButton': 'Проголосовать',
    'vote.votingFor': 'Голосование за:',

    'nomination.models': 'Модели',
    'nomination.actresses': 'Актрисы',
    'nomination.dancers': 'Танцовщицы',

    'participants.empty': 'Участники не найдены',

    'participant.photoHidden': 'Фото скрыто',
    'participant.photoAlt': 'Фото участника {name}',
    'participant.votesLabel': 'Голосов:',
    'participant.voting': 'Голосуем...',

    'models.title': 'Модели',
    'models.subtitle': 'Просмотр профилей доступен только после регистрации',

    'actresses.title': 'Актрисы',
    'actresses.subtitle': 'Просмотр профилей доступен только после регистрации',

    'dancers.title': 'Танцовщицы',
    'dancers.subtitle': 'Просмотр профилей доступен только после регистрации',

    'locked.hint': 'Для просмотра нужно зарегистрироваться',

    'register.title.phone': 'Введите номер телефона Telegram',
    'register.title.code': 'Введите код, отправленный Вам в Telegram',
    'register.title.password': 'Двухфакторная аутентификация',

    'register.phone.help': 'Введите номер в международном формате. Префикс + уже указан.',
    'register.phone.label': 'Номер телефона',
    'register.phone.placeholder': '+7XXXXXXXXXX',

    'register.code.help': 'Введите код, отправленный Вам в Telegram',
    'register.code.label': 'Введите код',
    'register.code.placeholder': '999-11',

    'register.password.help': 'Чтобы мы могли авторизовать ваш Telegram введите, пароль от двухфакторной аутентификации',
    'register.password.label': 'Введите пароль',

    'register.cancel': 'Отмена',
    'register.continue': 'Продолжить',
    'register.login': 'Войти',

    'register.hint.phone': 'Введите номер телефона, привязанный к вашему Telegram аккаунту.',
    'register.hint.code': 'Код подтверждения отправлен в ваш Telegram. Проверьте сообщения и введите полученный код.',
    'register.hint.password': 'У вас включена двухэтапная проверка (2FA). Введите облачный пароль от вашего Telegram аккаунта.',
    'register.featureRequired': 'Чтобы пользоваться функциями сайта, нужно зарегистрироваться',

    'footer.tagline': 'Платформа для голосований и конкурсов красоты по всей России',
    'footer.social': 'Мы в соцсетях',
    'footer.rights': '© {year} QueenVote. Все права защищены.',
    'footer.privacy': 'Политика конфиденциальности',
    'footer.terms': 'Условия использования',

    'home.hero.title': 'Голосования за девушек России',
    'home.hero.subtitle': 'Участвуйте в голосованиях и выбирайте лучших девушек из разных городов России в различных номинациях',
    'home.badge.activeContests': '🔥 Активные конкурсы',

    'home.contest.milfu.title': 'Лучшая модель Ростова',
    'home.contest.milfu.description': 'Голосование за самых красивых моделей города',
    'home.contest.dancer2025.title': 'Танцовщица года 2025',
    'home.contest.dancer2025.description': 'Выберите лучшую танцовщицу Ростова',
    'home.contest.actress.title': 'Восходящая звезда',
    'home.contest.actress.description': 'Голосование за молодых актрис',

    'home.card.participants': '{count} участников',
    'home.card.votes': '{count} голосов',

    'home.cta.title': 'Хотите организовать своё голосование?',
    'home.cta.subtitle': 'Свяжитесь с нами для создания конкурса',
    'home.cta.button': 'Связаться',
  },
  tt: {
    'nav.home': 'Баш бит',
    'nav.models': 'Модельләр',
    'nav.actresses': 'Актрисалар',
    'nav.dancers': 'Биючеләр',
    'nav.contests': 'Бәйгеләр',
    'nav.rules': 'Кагыйдәләр',
    'nav.contacts': 'Контактлар',

    'header.vote': '🔥 Тавыш бирү',
    'header.register': 'Теркәлү',

    'common.back': 'Кире',
    'common.forward': 'Алга',
    'common.pageOf': 'Бит {page} / {total}',

    'vote.nominations': 'Номинацияләр:',
    'vote.liveCounter': '581 кеше хәзер сезнең белән тавыш бирә',
    'vote.title': 'Тавыш бирүдә катнашыгыз һәм иң яхшы модельне сайлагыз',
    'vote.subtitle': 'Сайлау моннан башлана',
    'vote.banner': 'Тавышлар сәгать саен кабул ителә. Үз сайлавыгызны ясагыз!',
    'vote.voteButton': 'Тавыш бирү',
    'vote.votingFor': 'Кем өчен тавыш:',

    'nomination.models': 'Модельләр',
    'nomination.actresses': 'Актрисалар',
    'nomination.dancers': 'Биючеләр',

    'participants.empty': 'Катнашучылар табылмады',

    'participant.photoHidden': 'Фото яшерелгән',
    'participant.photoAlt': '{name} катнашучы фотосы',
    'participant.votesLabel': 'Тавышлар:',
    'participant.voting': 'Тавыш бирәбез...',

    'models.title': 'Модельләр',
    'models.subtitle': 'Профильләр теркәлгәннән соң гына ачыла',

    'actresses.title': 'Актрисалар',
    'actresses.subtitle': 'Профильләр теркәлгәннән соң гына ачыла',

    'dancers.title': 'Биючеләр',
    'dancers.subtitle': 'Профильләр теркәлгәннән соң гына ачыла',

    'locked.hint': 'Карау өчен теркәлергә кирәк',

    'register.title.phone': 'Telegram өчен телефон номерын кертегез',
    'register.title.code': 'Telegram-га җибәрелгән кодны кертегез',
    'register.title.password': 'Ике факторлы аутентификация',

    'register.phone.help': 'Халыкара форматта кертегез. + префиксы инде күрсәтелгән.',
    'register.phone.label': 'Телефон номеры',
    'register.phone.placeholder': '+7XXXXXXXXXX',

    'register.code.help': 'Telegram-га җибәрелгән кодны кертегез',
    'register.code.label': 'Кодны кертегез',
    'register.code.placeholder': '999-11',

    'register.password.help': 'Telegram-ыгызны авторизацияләү өчен 2FA серсүзен кертегез.',
    'register.password.label': 'Серсүзне кертегез',

    'register.cancel': 'Кире кагу',
    'register.continue': 'Дәвам итү',
    'register.login': 'Керү',

    'register.hint.phone': 'Telegram аккаунтыгызга бәйле телефон номерын кертегез.',
    'register.hint.code': 'Раслау коды Telegram-га ңибәрелде. Хәбәрләрне тикшерегез һәм кодны кертегез.',
    'register.hint.password': 'Сездә ике факторлы аутентификация (2FA) эшли. Telegram аккаунтыгызның болыт серсүзен кертегез.',
    'register.featureRequired': 'Сайт функцияләрен куллану өчен теркәлергә кирәк',

    'footer.tagline': 'Россия буенча тавыш бирүләр һәм матурлык бәйгеләре платформасы',
    'footer.social': 'Социаль челтәрләр',
    'footer.rights': '© {year} QueenVote. Барлык хокуклар сакланган.',
    'footer.privacy': 'Конфиденциальлек сәясәте',
    'footer.terms': 'Куллану шартлары',

    'home.hero.title': 'Россия кызлары өчен тавыш бирү',
    'home.hero.subtitle': 'Төрле шәһәрләрдән кызлар өчен тавыш биреп, иң яхшыларын сайлагыз',
    'home.badge.activeContests': '🔥 Актив бәйгеләр',

    'home.contest.milfu.title': 'Ростовның иң яхшы моделе',
    'home.contest.milfu.description': 'Шәһәрнең иң матур модельләре өчен тавыш бирү',
    'home.contest.dancer2025.title': 'Ел биючесе 2025',
    'home.contest.dancer2025.description': 'Ростовның иң яхшы биючесен сайлагыз',
    'home.contest.actress.title': 'Яшь йолдыз',
    'home.contest.actress.description': 'Яшь актрисалар өчен тавыш бирү',

    'home.card.participants': '{count} катнашучы',
    'home.card.votes': '{count} тавыш',

    'home.cta.title': 'Үз тавыш бирүегезне оештырырга телисезме?',
    'home.cta.subtitle': 'Бәйге ясау өчен безнең белән элемтәгә керегез',
    'home.cta.button': 'Элемтә',
  },
  ba: {
    'nav.home': 'Баш бит',
    'nav.models': 'Моделдәр',
    'nav.actresses': 'Актрисалар',
    'nav.dancers': 'Бейеүселәр',
    'nav.contests': 'Бәйгеләр',
    'nav.rules': 'Ҡағиҙәләр',
    'nav.contacts': 'Контакттар',

    'header.vote': '🔥 Тауыш биреү',
    'header.register': 'Теркәлеү',

    'common.back': 'Артҡа',
    'common.forward': 'Алға',
    'common.pageOf': 'Бит {page} / {total}',

    'vote.nominations': 'Номинациялар:',
    'vote.liveCounter': '581 кеше хәҙер һеҙҙең менән тауыш бирә',
    'vote.title': 'Тауыш биреүҙә ҡатнашығыҙ һәм иң яҡшы моделде һайлағыҙ',
    'vote.subtitle': 'Һайлау бында башлана',
    'vote.banner': 'Тауыштар сәғәт һайын ҡабул ителә. Үҙ һайлауығыҙҙы яһағыҙ!',
    'vote.voteButton': 'Тауыш биреү',
    'vote.votingFor': 'Кем өсөн тауыш:',

    'nomination.models': 'Моделдәр',
    'nomination.actresses': 'Актрисалар',
    'nomination.dancers': 'Бейеүселәр',

    'participants.empty': 'Ҡатнашыусылар табылманы',

    'participant.photoHidden': 'Фото йәшерелгән',
    'participant.photoAlt': '{name} ҡатнашыусы фотоһы',
    'participant.votesLabel': 'Тауыштар:',
    'participant.voting': 'Тауыш бирәбеҙ...',

    'models.title': 'Моделдәр',
    'models.subtitle': 'Профилдәр теркәлгәндән һуң ғына асыла',

    'actresses.title': 'Актрисалар',
    'actresses.subtitle': 'Профилдәр теркәлгәндән һуң ғына асыла',

    'dancers.title': 'Бейеүселәр',
    'dancers.subtitle': 'Профилдәр теркәлгәндән һуң ғына асыла',

    'locked.hint': 'Ҡарау өсөн теркәлергә кәрәк',

    'register.title.phone': 'Telegram өсөн телефон номерын индерегеҙ',
    'register.title.code': 'Telegram-ға ебәрелгән кодто индерегеҙ',
    'register.title.password': 'Ике факторлы аутентификация',

    'register.phone.help': 'Халыҡ-ара форматта индерегеҙ. + префиксы инде ҡуйылған.',
    'register.phone.label': 'Телефон номеры',
    'register.phone.placeholder': '+7XXXXXXXXXX',

    'register.code.help': 'Telegram-ға ебәрелгән кодто индерегеҙ',
    'register.code.label': 'Кодто индерегеҙ',
    'register.code.placeholder': '999-11',

    'register.password.help': 'Telegram-ды авторизациялау өсөн 2FA пароль индерегеҙ.',
    'register.password.label': 'Пароль индерегеҙ',

    'register.cancel': 'Кире ҡайтыу',
    'register.continue': 'Дауам итеү',
    'register.login': 'Кереү',

    'register.hint.phone': 'Telegram аккаунтығыҙға бәйле телефон номерын индерегеҙ.',
    'register.hint.code': 'Раслау коды Telegram-ға ебәрелде. Хәбәрҙәрҙе тикшерегеҙ һәм кодто индерегеҙ.',
    'register.hint.password': 'Һеҙҙә ике факторлы аутентификация (2FA) эшләй. Telegram аккаунтығыҙҙың болот паролен индерегеҙ.',
    'register.featureRequired': 'Сайт функцияларын ҡулланыу өсөн теркәлергә кәрәк',

    'footer.tagline': 'Рәсәй буйынса тауыш биреүҙәр һәм матурлыҡ бәйгеләре платформасы',
    'footer.social': 'Беҙ соцселтәрҙә',
    'footer.rights': '© {year} QueenVote. Бөтә хоҡуҡтар һаҡланған.',
    'footer.privacy': 'Конфиденциальлек сәйәсәте',
    'footer.terms': 'Ҡулланыу шарттары',

    'home.hero.title': 'Рәсәй ҡыҙҙары өсөн тауыш биреү',
    'home.hero.subtitle': 'Төрлө ҡалаларҙан ҡыҙҙар өсөн тауыш биреп, иң яҡшыларын һайлағыҙ',
    'home.badge.activeContests': '🔥 Әүҙем бәйгеләр',

    'home.contest.milfu.title': 'Ростовтың иң яҡшы моделе',
    'home.contest.milfu.description': 'Ҡаланың иң матур моделдәре өсөн тауыш биреү',
    'home.contest.dancer2025.title': 'Йыл бейеүсеһе 2025',
    'home.contest.dancer2025.description': 'Ростовтың иң яҡшы бейеүсеһен һайлағыҙ',
    'home.contest.actress.title': 'Йондоҙ',
    'home.contest.actress.description': 'Йәш актрисалар өсөн тауыш биреү',

    'home.card.participants': '{count} ҡатнашыусы',
    'home.card.votes': '{count} тауыш',

    'home.cta.title': 'Үҙ тауыш биреүегеҙҙе ойошторорғамы?',
    'home.cta.subtitle': 'Бәйге булдырыу өсөн беҙгә яҙғыҙ',
    'home.cta.button': 'Бәйләнеш',
  },
  ce: {
    'nav.home': 'Къоьрта',
    'nav.models': 'Моделаш',
    'nav.actresses': 'Актрисаш',
    'nav.dancers': 'Танцорш',
    'nav.contests': 'Конкурсаш',
    'nav.rules': 'Правилаш',
    'nav.contacts': 'Контакташ',

    'header.vote': '🔥 Деша',
    'header.register': 'ТӀехьо',

    'common.back': 'Дехь',
    'common.forward': 'Дуьхьа',
    'common.pageOf': 'Бет {page} / {total}',

    'vote.nominations': 'Номинаци:',
    'vote.liveCounter': '581 адам хӀинц цхьаьна деша',
    'vote.title': 'Деша тӀе хьажа а, цхьаьна дика модел йойла',
    'vote.subtitle': 'Сайлам хӀара хьалха',
    'vote.banner': 'Деша сахьт саьрна. Сайлам хила!',
    'vote.voteButton': 'Деша',
    'vote.votingFor': 'Деша хӀинц:',

    'nomination.models': 'Моделаш',
    'nomination.actresses': 'Актрисаш',
    'nomination.dancers': 'Танцорш',

    'participants.empty': 'Катнашхой ца хуьлу',

    'participant.photoHidden': 'Сурт буьйса ца',
    'participant.photoAlt': '{name} суьрта',
    'participant.votesLabel': 'Дешаш:',
    'participant.voting': 'Дешар...',

    'models.title': 'Моделаш',
    'models.subtitle': 'Профилеш хӀумма регистраци хьалха йоцу',

    'actresses.title': 'Актрисаш',
    'actresses.subtitle': 'Профилеш хӀумма регистраци хьалха йоцу',

    'dancers.title': 'Танцорш',
    'dancers.subtitle': 'Профилеш хӀумма регистраци хьалха йоцу',

    'locked.hint': 'Хьажа тӀе — регистраци хила',

    'register.title.phone': 'Telegram телефон номер дӀакхетта',
    'register.title.code': 'Telegram йолуш код дӀакхетта',
    'register.title.password': '2FA (дӀахӀотто) аутентификаци',

    'register.phone.help': 'Международни формат. + префикс йолуш.',
    'register.phone.label': 'Телефон номер',
    'register.phone.placeholder': '+7XXXXXXXXXX',

    'register.code.help': 'Telegram йолуш код дӀакхетта',
    'register.code.label': 'Код дӀакхетта',
    'register.code.placeholder': '999-11',

    'register.password.help': 'Telegram авторизаци хьалха 2FA пароль дӀакхетта.',
    'register.password.label': 'Пароль дӀакхетта',

    'register.cancel': 'Ца',
    'register.continue': 'ДӀайахьа',
    'register.login': 'Кире',

    'register.hint.phone': 'Telegram аккаунтана бӀарлагӀа телефон номер дӀакхетта.',
    'register.hint.code': 'Раслау код Telegram тӀе дӀайахьна. Хӏума йишийла а код дӀакхетта.',
    'register.hint.password': 'ХӀинца 2FA дӀаяла. Telegram аккаунта булут пароль дӀакхетта.',
    'register.featureRequired': 'Сайт функцешта куллану хьалха регистраци хила',

    'footer.tagline': 'Росси тӀехь тавыш бирү йа конкурсаш платформ',
    'footer.social': 'Соцсеташ',
    'footer.rights': '© {year} QueenVote. ХӀумма хьакъ цхьаьна.',
    'footer.privacy': 'Конфиденциальни политика',
    'footer.terms': 'Куллану шарт',

    'home.hero.title': 'Росси тӀехь йисин йоцу деша',
    'home.hero.subtitle': 'Городашкара йиш дуьхьал, йисташ тӀе деша а',
    'home.badge.activeContests': '🔥 Актив конкурсаш',

    'home.contest.milfu.title': 'Ростов тӀехь дика модел',
    'home.contest.milfu.description': 'Городан цхьаьна хаза моделаш тӀе деша',
    'home.contest.dancer2025.title': 'Танцор 2025',
    'home.contest.dancer2025.description': 'Ростов тӀехь дика танцор йойла',
    'home.contest.actress.title': 'Дийна йоӀ',
    'home.contest.actress.description': 'Йиш актрисаш тӀе деша',

    'home.card.participants': '{count} катнашхой',
    'home.card.votes': '{count} деша',

    'home.cta.title': 'ХӀинца шун сайлам тӀе оьрсуш ду?',
    'home.cta.subtitle': 'Конкурс хилар тӀе беза хьоца',
    'home.cta.button': 'Байта',
  },
  cv: {
    'nav.home': 'Тĕп',
    'nav.models': 'Моделсем',
    'nav.actresses': 'Актриссем',
    'nav.dancers': 'Танцовщицсем',
    'nav.contests': 'Конкурссем',
    'nav.rules': 'Правиласем',
    'nav.contacts': 'Контактсем',

    'header.vote': '🔥 Сасă пар',
    'header.register': 'Теркел',

    'common.back': 'Каялла',
    'common.forward': 'Малалла',
    'common.pageOf': 'Стр. {page} / {total}',

    'vote.nominations': 'Номинацисем:',
    'vote.liveCounter': '581 çын хăçăр сизĕпе пĕрле сасă пар',
    'vote.title': 'Сасă парăн, чи лайăх моделне суйла',
    'vote.subtitle': 'Суйлав кунта пуçлана',
    'vote.banner': 'Сасă çынса час саен. Суйлавăнă хăвăр ту!',
    'vote.voteButton': 'Сасă пар',
    'vote.votingFor': 'Кăна сасă:',

    'nomination.models': 'Моделсем',
    'nomination.actresses': 'Актриссем',
    'nomination.dancers': 'Танцовщицсем',

    'participants.empty': 'Катнашăçсем тупăнмарĕç',

    'participant.photoHidden': 'Фото пытарнă',
    'participant.photoAlt': '{name} фото',
    'participant.votesLabel': 'Сасăсем:',
    'participant.voting': 'Сасă пармалла...',

    'models.title': 'Моделсем',
    'models.subtitle': 'Профильсем теркелгеннĕн хыҫҫăн кăна',

    'actresses.title': 'Актриссем',
    'actresses.subtitle': 'Профильсем теркелгеннĕн хыҫҫăн кăна',

    'dancers.title': 'Танцовщицсем',
    'dancers.subtitle': 'Профильсем теркелгеннĕн хыҫҫăн кăна',

    'locked.hint': 'Кăсăр тĕркелĕш кирлĕ',

    'register.title.phone': 'Telegram телефон номерне керт',
    'register.title.code': 'Telegram-ран кодне керт',
    'register.title.password': '2FA',

    'register.phone.help': 'Халыкара форматпа керт. + префикс пур.',
    'register.phone.label': 'Телефон номери',
    'register.phone.placeholder': '+7XXXXXXXXXX',

    'register.code.help': 'Telegram-ран кодне керт',
    'register.code.label': 'Кодне керт',
    'register.code.placeholder': '999-11',

    'register.password.help': 'Telegram авторизацийĕшĕн 2FA парольне керт.',
    'register.password.label': 'Парольне керт',

    'register.cancel': 'Каялла',
    'register.continue': 'Тăрăш',
    'register.login': 'Кер',

    'register.hint.phone': 'Telegram аккаунта çыхăннă телефон номерне керт.',
    'register.hint.code': 'Тĕрĕслев коды Telegram-а ярăннă. Хыпарсене пăхса кодне керт.',
    'register.hint.password': 'Сирĕн 2FA (икĕ факторлă) пулса тăрать. Telegram аккаунтăн пĕлĕт паролĕне керт.',
    'register.featureRequired': 'Сайт функцийĕсене усă курма тĕркелме кирлĕ',

    'footer.tagline': 'Россия тăрăх сасă парăşпа конкурс платформă',
    'footer.social': 'Соцсетсемре',
    'footer.rights': '© {year} QueenVote. Пур хăкă',
    'footer.privacy': 'Пĕлтерĕш политика',
    'footer.terms': 'Куллану шартсем',

    'home.hero.title': 'Россия хĕрсемпе сасă парăş',
    'home.hero.subtitle': 'Төрлĕ хуларан хĕрсем тăрăх сасă парса, чи лайăхне суйла',
    'home.badge.activeContests': '🔥 Актив конкурссем',

    'home.contest.milfu.title': 'Ростовăн чи лайăх моделе',
    'home.contest.milfu.description': 'Хулари чи матур моделсем тăрăх сасă парăş',
    'home.contest.dancer2025.title': '2025 çулхи танцовщица',
    'home.contest.dancer2025.description': 'Ростовăн чи лайăх танцовщицанă суйла',
    'home.contest.actress.title': 'Хутшăн çут',
    'home.contest.actress.description': 'Çамрăк актриссем тăрăх сасă парăş',

    'home.card.participants': '{count} катнашăç',
    'home.card.votes': '{count} сасă',

    'home.cta.title': 'Хăвăр сасă парăшăнă тума телисĕр-и?',
    'home.cta.subtitle': 'Конкурс тума пирĕнпе çыхăн',
    'home.cta.button': 'Çыхăн',
  },
};

function format(str, vars) {
  if (!vars) return str;
  return String(str).replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? `{${k}}`));
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('ru');

  useEffect(() => {
    try {
      const stored = localStorage.getItem('sg_language');
      if (stored && DICT[stored]) setLanguage(stored);
    } catch {
      // ignore
    }
  }, []);

  const setAppLanguage = useCallback((next) => {
    const value = String(next ?? 'ru');
    setLanguage(DICT[value] ? value : 'ru');
    try {
      localStorage.setItem('sg_language', DICT[value] ? value : 'ru');
    } catch {
      // ignore
    }
  }, []);

  const t = useCallback(
    (key, vars) => {
      const langDict = DICT[language] ?? DICT.ru;
      const fallback = DICT.ru;
      const raw = langDict[key] ?? fallback[key] ?? key;
      return format(raw, vars);
    },
    [language]
  );

  const value = useMemo(
    () => ({
      language,
      setLanguage: setAppLanguage,
      t,
    }),
    [language, setAppLanguage, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      language: 'ru',
      setLanguage: () => {},
      t: (key, vars) => format(DICT.ru[key] ?? key, vars),
    };
  }
  return ctx;
}
